import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';

export const authInterceptor: HttpInterceptorFn = (req, next) =>
{
  const storage = inject(StorageService);
  const token = storage.get('access_token');
  if (token)
  {
    const clonedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${ token }`,
      },
    });
    return next(clonedReq);
  }

  return next(req);
};
